import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { WizardStep } from '../../../../wizard/wizard.component';
import { FormGroup, FormBuilder } from '@angular/forms';
import { NotificationToastService } from '../../../../services/notification-toast.service';
import { StudyReportSendWizardService } from '../../../../services/wizard/logistic/study-report-send-wizard';
import { StudyReportBatchItemInfo } from 'src/app/model/logistics/study-report';
import { MatTableDataSource } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';

@Component({
  selector: 'app-receive-study-report-logistics-item',
  templateUrl: './receive-study-report-logistics-item.component.html'
})
export class ReceiveStudyReportLogisticsItemComponent implements OnInit, WizardStep {

  form: FormGroup;
  loading: boolean;
  isInit: boolean;
  proNoAdded: string;
  proAdded: string;
  noFindProtocols: string[] = [];

  @ViewChild('newProtocol', {static: false}) newProtocol: ElementRef;
  displayColumns = ['select', 'Protocol', 'PracticeRegionName', 'PatientFullName', 'PreviousStudies', 'PreviousStudiesAmount'
  , 'PreviousStudiesDetails', 'RegionName'];

  dataSource = new MatTableDataSource([]);
  selection = new SelectionModel<StudyReportBatchItemInfo>(true, []);

  constructor(private studyReportSendWizardService: StudyReportSendWizardService
    , private notificationToastService: NotificationToastService
    , private formBuilder: FormBuilder) {
    this.form = this.formBuilder.group({
      StudyReportBatchItems: this.formBuilder.array([]),
      NewProtocol: ['']
    });
  }

  get completed(): boolean { return true; }

   /** Whether the number of selected elements matches the total number of rows. */
   isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  ngOnInit(): void {
    this.isInit = true;
  }

  get valid(): boolean {
    return this.completed;
  }


  activate(): void {
    const items = this.studyReportSendWizardService.getStudyReportBatchItems();
    this.addItems(items);
    setTimeout(() => this.newProtocol.nativeElement.focus(), 0);
  }

  private addItems(items: StudyReportBatchItemInfo[]) {
    this.dataSource = new MatTableDataSource(items);
    items.forEach((item) => {
      item.IsReceive = true;
      this.selection.select(item);
    });
  }

  save(): void {
    this.studyReportSendWizardService.getStudyReportBatchItems().forEach((item) => {
      item.IsReceive = this.selection.isSelected(item);
    });
  }

  protocolNoAdded(): string {
    return this.proNoAdded;
  }

  protocolAdded(): string {
    return this.proAdded;
  }

  private findProtocol(findProtocol: string, item: StudyReportBatchItemInfo) {
    let find = false;
    const re = /\-/gi;
    findProtocol = findProtocol.replace(re, '');
    const protocol = item.Protocol.replace(re, '');
    find = protocol === findProtocol;
    return find;
  }

  async addProtocol() {
    if (this.form.valid) {
      const items = this.studyReportSendWizardService.getStudyReportBatchItems();
      const re = /\-/gi;
      const findProtocol = this.form.controls.NewProtocol.value.replace(re, '');
      let find = false;

      items.forEach((item) => {
        if (this.findProtocol(findProtocol, item)) {
          find = true;
          this.selection.select(item);
          this.proAdded = this.form.controls.NewProtocol.value;
          this.proNoAdded = null;
        }
      });

      if (!find) {
        this.notificationToastService.error('Protocolo NO encontrado', 'Recepción de órdenes');
        this.noFindProtocols.push( this.form.controls.NewProtocol.value);
        this.proAdded = null;
        this.proNoAdded = this.form.controls.NewProtocol.value;
      } else {
        this.notificationToastService.success('Protocolo encontrado', 'Recepción de órdenes');
      }

      this.form.patchValue({ NewProtocol: '' });
      setTimeout(() => this.newProtocol.nativeElement.focus(), 0);
    }
  }
}
